import { useMutation, useQueryClient } from '@tanstack/react-query'

import { postRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'
import type { LeadDistributionPreference } from 'src/shared/features/enterprise/api/use-update-enterprise-settings'

import type { EnterpriseDistributionSystemResponse } from './use-lead-distributions'

export interface CreateEnterpriseDistributionSystemParams {
  enterpriseId: number
  name: string
  distributionType: LeadDistributionPreference
  memberUserIds: number[]
}

const createEnterpriseDistributionSystem = async (params: CreateEnterpriseDistributionSystemParams) => {
  const { enterpriseId, name, distributionType, memberUserIds } = params
  return postRequest<EnterpriseDistributionSystemResponse>(`/enterprise/${enterpriseId}/distribution-systems`, {
    name,
    distribution_type: distributionType,
    member_user_ids: memberUserIds,
  })
}

export default function useCreateLeadDistribution() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (params: CreateEnterpriseDistributionSystemParams) => {
      const response = await createEnterpriseDistributionSystem(params)

      if (!response) {
        throw new Error('No response received from create distribution system')
      }

      queryClient.invalidateQueries({ queryKey: queries.enterprise.distributionSystems._def })

      return response
    },
  })
}
